// Role
export const ROLE_REQUEST = "ROLE_REQUEST";
export const ROLE_SUCCESS = "ROLE_SUCCESS";
export const ROLE_FAIL = "ROLE_FAIL";
export const ROLE_CLEAR_ERRORS = "ROLE_CLEAR_ERRORS";

// Company Type

export const COMPANY_REQUEST = "COMPANY_REQUEST";
export const COMPANY_SUCCESS = "COMPANY_SUCCESS";
export const COMPANY_FAIL = "COMPANY_FAIL";
export const COMPANY_CLEAR_ERRORS = "COMPANY_CLEAR_ERRORS";

// Market Share

export const MARKET_SHARE_REQUEST = "MARKET_SHARE_REQUEST";
export const MARKET_SHARE_SUCCESS = "MARKET_SHARE_SUCCESS";
export const MARKET_SHARE_FAIL = "MARKET_SHARE_FAIL";
export const MARKET_SHARE_CLEAR_ERRORS = "MARKET_SHARE_CLEAR_ERRORS";

// Industry

export const INDUSTRY_REQUEST = "INDUSTRY_REQUEST";
export const INDUSTRY_SUCCESS = "INDUSTRY_SUCCESS";
export const INDUSTRY_FAIL = "INDUSTRY_FAIL";
export const INDUSTRY_CLEAR_ERRORS = "INDUSTRY_CLEAR_ERRORS";

//  annual revenue

export const ANNUAL_REVENUE_REQUEST = "ANNUAL_REVENUE_REQUEST";
export const ANNUAL_REVENUE_SUCCESS = "ANNUAL_REVENUE_SUCCESS";
export const ANNUAL_REVENUE_FAIL = "ANNUAL_REVENUE_FAIL";
export const ANNUAL_REVENUE_CLEAR_ERRORS = "ANNUAL_REVENUE_CLEAR_ERRORS";

// total head count

export const TOTAL_HEAD_COUNT_REQUEST = "TOTAL_HEAD_COUNT_REQUEST";
export const TOTAL_HEAD_COUNT_SUCCESS = "TOTAL_HEAD_COUNT_SUCCESS";
export const TOTAL_HEAD_COUNT_FAIL = "TOTAL_HEAD_COUNT_FAIL";
export const TOTAL_HEAD_COUNT_CLEAR_ERRORS = "TOTAL_HEAD_COUNT_CLEAR_ERRORS";
